var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "d-flex flex-column gr-2",
        attrs: { "data-qa": "steps_to_follow" },
      },
      [
        _c("div", { staticClass: "d-flex gc-3" }, [
          _c("div", { staticClass: "bg-club-gradient rounded-sm px-1" }),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex flex-column gr-1" }, [
            _c("div", { staticClass: "text-subtitle-1 text--text" }, [
              _vm._v("\n        Шаг 1\n      "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-body-2 text--text" }, [
              _vm._v(
                "\n        Приобретаете при записи к врачу опцион, дающий право на скидку\n      "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex gc-3" }, [
          _c("div", { staticClass: "bg-club rounded-sm px-1" }),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex flex-column gr-1" }, [
            _c(
              "div",
              { staticClass: "text-subtitle-1 text-secondary--text mb-1" },
              [_vm._v("\n        Шаг 2\n      ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-body-2 text--text" }, [
              _vm._v(
                "\n        Показываете опцион администратору в клинике и получаете скидку\n      "
              ),
            ]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }